export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13767.a64b7496.jpg";